// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2n0ad","switch_control":"switch_control-3NF_p","switch_active":"switch_active-VCJBR","price_wrapper":"price_wrapper-3p6IJ","switch_wrapper":"switch_wrapper-3r_iF"};